// Reusable flow (inflow/outflow) section for the LiquidityDetails modal.
import { Repeat, HandCoins, Handshake, Vault, TrendingUp, TrendingDown, Gift } from "lucide-react";

const IN_META = {
  income: { icon: TrendingUp, color: "text-emerald-600" },
  revenue: { icon: Gift, color: "text-cyan-600" },
  borrow: { icon: HandCoins, color: "text-violet-600" },
  repay_lend: { icon: Repeat, color: "text-emerald-500" },
};
const OUT_META = {
  expense: { icon: TrendingDown, color: "text-red-600" },
  recurring: { icon: Repeat, color: "text-indigo-600" },
  savings: { icon: Vault, color: "text-amber-600" },
  lend: { icon: Handshake, color: "text-teal-600" },
  repay_borrow: { icon: Repeat, color: "text-red-500" },
};

const fmt = (n) => Math.round(Number(n || 0)).toLocaleString();

export function LiquidityFlow({ direction, byType, total, labels, title, headerClass, totalClass, sign }) {
  const META = direction === "in" ? IN_META : OUT_META;
  const keys = Object.keys(META).filter((k) => byType[k]);
  if (!keys.length) return null;
  return (
    <div className="p-3 rounded-2xl neu-sm mb-3">
      <p className={`text-xs font-bold mb-1 ${headerClass}`}>{title}</p>
      {keys.map((k) => {
        const Ic = META[k].icon;
        return (
          <div key={k} className="flex items-center gap-2.5 py-1.5">
            <Ic className={`w-4 h-4 shrink-0 ${META[k].color}`} />
            <p className="text-sm flex-1 truncate">{labels[k]}</p>
            <span className={`font-display font-extrabold text-sm tabular-nums ${META[k].color}`}>
              {sign}{fmt(byType[k])}
            </span>
          </div>
        );
      })}
      <div className={`border-t border-slate-200 mt-2 pt-2 flex items-center justify-between ${headerClass}`}>
        <span className="text-xs font-bold">{labels._total}</span>
        <span className={`font-display font-extrabold tabular-nums ${totalClass}`}>{sign}{fmt(total)}</span>
      </div>
    </div>
  );
}
